import Button from "../support/Button";
import CartButton from "./CartButton";
import styles from "./NavActions.module.scss";
import NavLanguageSwitcher from "./NavLanguageSwitcher";
import NavbarUserProfile from "./NavbarUserProfile";

export default function NavActions() {
  const isNonOrderRoute = false;
  const shouldHideCartButton = false;
  const isShowProfile = true;
  const isShowSignIn = true;

  return (
    <>
      {!isNonOrderRoute && (
        <div className={styles.actionButtonContainer}>
          {!shouldHideCartButton && <CartButton />}

          <>
            {isShowProfile && <NavbarUserProfile />}
            {isShowSignIn && (
              <Button
                size="large"
                variant="tertiary"
                className={styles.signInButton}
              >
                Sign In
              </Button>
            )}
          </>
        </div>
      )}
      <NavLanguageSwitcher />
    </>
  );
}
